import React from 'react'
import PropTypes from 'prop-types'

import StandardButton from '../app_components/StandardButton'
import BlockUserModal from '../profile_sections/BlockUserModal'

class BlockedUsersSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      blockedUsers: [],
      loading: true,
      unblockTarget: null,
    }

    this.fetchBlockedUsers = this.fetchBlockedUsers.bind(this)
    this.openUnblockModal = this.openUnblockModal.bind(this)
    this.closeUnblockModal = this.closeUnblockModal.bind(this)
    this.handleUnblocked = this.handleUnblocked.bind(this)
  }

  componentDidMount() {
    this.fetchBlockedUsers()
  }

  fetchBlockedUsers() {
    $.ajax({
      url: '/blocked_users.json',
      dataType: 'JSON',
      type: 'GET',
      success: (response) => {
        this.setState({
          blockedUsers: response.data || [],
          loading: false,
        })
      },
      error: () => {
        this.setState({ loading: false })
      },
    })
  }

  openUnblockModal(blockedUser) {
    this.setState({ unblockTarget: blockedUser })
  }

  closeUnblockModal() {
    this.setState({ unblockTarget: null })
  }

  handleUnblocked() {
    this.closeUnblockModal()
    this.fetchBlockedUsers()
  }

  renderUserRow(blockedUser) {
    const avatarSrc = (!blockedUser.avatar_url || blockedUser.avatar_url.includes('missing'))
      ? this.props.missingImgUrl
      : blockedUser.avatar_url
    const profileUrl = blockedUser.slug ? `/profile/${blockedUser.slug}` : `/profile/${blockedUser.blocked_user_id}`

    return (
      <div key={blockedUser.id} className="blockedUsersSection__row">
        <a href={profileUrl} className="blockedUsersSection__user">
          <img
            src={avatarSrc}
            alt=""
            className="blockedUsersSection__avatar"
          />
          <span className="blockedUsersSection__name">
            {blockedUser.preferred_name}
          </span>
        </a>
        <StandardButton
          text="Unblock"
          size="small"
          variant="destructive"
          onClick={() => this.openUnblockModal(blockedUser)}
        />
      </div>
    )
  }

  render() {
    const { blockedUsers, loading, unblockTarget } = this.state

    if (loading || blockedUsers.length === 0) {
      return null
    }

    return (
      <section className="blockedUsersSection">
        <h3 className="blockedUsersSection__title">Blocked users</h3>
        <p className="blockedUsersSection__text greyText">
          Users you have blocked cannot request to connect with you.
        </p>
        <div className="blockedUsersSection__list">
          {blockedUsers.map((blockedUser) => this.renderUserRow(blockedUser))}
        </div>

        {unblockTarget && (
          <BlockUserModal
            userId={unblockTarget.blocked_user_id}
            userName={unblockTarget.preferred_name}
            currentUserId={this.props.currentUserId}
            isBlocker={true}
            blockedRecordId={unblockTarget.id}
            onClose={this.closeUnblockModal}
            onBlocked={this.closeUnblockModal}
            onUnblocked={this.handleUnblocked}
          />
        )}
      </section>
    )
  }
}

BlockedUsersSection.propTypes = {
  currentUserId: PropTypes.number.isRequired,
  missingImgUrl: PropTypes.string.isRequired,
}

export default BlockedUsersSection
